module.exports = __webpack_public_path__ + "media/application/images/icons/thumbdown-solid-ccc6964bfe361c3c5cd5f4eb33b673f1.svg";